module.exports = ".btn {\r\n  color: #fff !important;\r\n}\r\n"